import { bootstrap } from 'bootstrap';
import AscendingNumber from "../components/ascending-number/ascending-number.js";
import CareersSearch from "../components/careers-search/careers-search.js";
import DrugListing from '../components/drug-listing/drug-listing.js';
import Glossary from "../components/glossary/glossary.js";
import Header from "../components/header/header.js";
import HeroSwiper from "../components/hero-swiper/hero-swiper.js";
import LatestNewsList from "../components/news/news-list.js";
import MessageModal from "../components/modal-message/modal-message.js";
import NewsSwiper from "../components/news/news-swiper.js";
import ScrollTo from '../components/scroll-to-id/scroll-to-id.js';
import Swiper1 from "../components/swiper-1/swiper-1.js";
import SwiperCards from "../components/swiper-cards/swiper-cards.js";
import SwiperCards2 from "../components/swiper-cards/swiper-cards-2.js";
import SwiperClients from "../components/swiper-clients/swiper-clients.js";
import SwiperImages from "../components/swiper-images/swiper-images.js";
import SwiperBlog from "../components/swiper-blog/swiper-blog.js";
import SwiperLocations from "../components/swiper-locations/swiper-locations.js";
import SwiperMap from "../components/swiper-map/swiper-map.js";
import SwiperNews from "../components/swiper-news/swiper-news.js";
import SwiperQuote from "../components/quote/swiper-quote.js";
import SwiperQuote2 from "../components/quote/swiper-quote-2.js";
import SwiperRolloverCards from "../components/swiper-rollover-cards/swiper-rollover-cards.js";
import SwiperTimeline from "../components/swiper-timeline/swiper-timeline.js";
import Video from "../components/video/video.js";

console.log('%cMovianto - Here we go!', 'color: green; font-size: 13px');

if (document.querySelector(".ascending-number")) {
  let ascendingNumber = new AscendingNumber();
  ascendingNumber.init();
}

if (document.querySelector(".careers-search")) {
  let careersSearch = new CareersSearch();
  careersSearch.init();
}

if( document.querySelector('.drug-listing') ) {
  let drugListing = new DrugListing();
  drugListing.init();
}

if (document.querySelector(".glossary")) {
  let glossary = new Glossary();
  glossary.init();
}

if (document.querySelector(".swiper-1")) {
  let swiper1 = new Swiper1();
  swiper1.init();
}

if (document.querySelector(".swiper-clients")) {
  let swiperClients = new SwiperClients();
  swiperClients.init();
}

if (document.querySelector(".swiper-cards")) {
  let swiperCards = new SwiperCards();
  swiperCards.init();
}

if (document.querySelector(".swiper-cards-2")) {
  let swiperCards2 = new SwiperCards2();
  swiperCards2.init();
}


if (document.querySelector(".swiper-image")) {
  let swiperImages = new SwiperImages();
  swiperImages.init();
}

if (document.querySelector(".hero-swiper")) {
  let heroSwiper = new HeroSwiper();
  heroSwiper.init();
}

if (document.querySelector(".news--list")) {
  let latestNewsList = new LatestNewsList();
  latestNewsList.init();
}

if (document.querySelector(".modal-message")) {
  let messageModal = new  MessageModal();
  messageModal.init();
}

if (document.querySelector(".navbar")) {
  let header = new Header();
  header.init();
}

if (document.querySelector(".news-swiper")) {
  let newsSwiper = new NewsSwiper();
  newsSwiper.init();
}

if (document.querySelector(".swiper-blog")) {
  let swiperBlog = new SwiperBlog();
  swiperBlog.init();
}

if (document.querySelector(".swiper-locations")) {
  let swiperLocations = new SwiperLocations();
  swiperLocations.init();
}

if (document.querySelector(".swiper-map")) {
  let swiperMap = new SwiperMap();
  swiperMap.init();
}

if (document.querySelector(".swiper-news")) {
  let swiperNews = new SwiperNews();
  swiperNews.init();
}

if (document.querySelector(".swiper-quote")) {
  let swiperQuote = new SwiperQuote();
  swiperQuote.init();
}

if (document.querySelector(".swiper-quote-2")) {
  let swiperQuote2 = new SwiperQuote2();
  swiperQuote2.init();
}

if (document.querySelector(".swiper-rollover-cards")) {
  let swiperRolloverCards = new SwiperRolloverCards();
  swiperRolloverCards.init();
}

if (document.querySelector(".swiper-timeline")) {
  let swiperTimeline = new SwiperTimeline();
  swiperTimeline.init();
}

if (document.querySelector(".scroll-to")) {
  let scrollTo = new ScrollTo();
  scrollTo.init();
}

if (document.querySelector(".video")) {
  let video = new Video();
  video.init();
}